/**
 * Password validation utility
 * Validates password strength using the same rules as backend
 */

/**
 * Password validation result interface
 */
export interface PasswordValidationResult {
  valid: boolean
  errors: string[]
}

/**
 * Validate password strength using simple character class rules
 * Requirements:
 * - Minimum length: 12 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one digit
 * - At least one special character (non alphanumeric)
 *
 * @param password Plain text password to validate
 * @returns Validation result with error messages in English
 */
export function validatePasswordStrength(password: string): PasswordValidationResult {
  const errors: string[] = []

  if (!password || password.length < 12) {
    errors.push('Password must be at least 12 characters long.')
  }
  if (!/[A-Z]/.test(password)) {
    errors.push('Password must contain at least one uppercase letter.')
  }
  if (!/[a-z]/.test(password)) {
    errors.push('Password must contain at least one lowercase letter.')
  }
  if (!/[0-9]/.test(password)) {
    errors.push('Password must contain at least one digit.')
  }
  if (!/[^A-Za-z0-9]/.test(password)) {
    errors.push('Password must contain at least one special character.')
  }
  return {
    valid: errors.length === 0,
    errors,
  }
}

